module.exports = {"TXTWCL_Less_than_1X":{"id":"TXTWCL_Less_than_1X","defaultMessage":"Меньше 1''"}}